export const ITEM_TEMPLATE = {
  num: '',
  name: '',
  taxIncludedUnitPrice: 0,
  taxExcludedUnitPrice: 0,
  count: 0,
  quantityUnit: '',
  date: '',
  dateN: null,
  taxIncludedPrice: 0,
  taxExcludedPrice: 0,
  taxAmount: 0,
  taxInfo: '',
  discount: 0,
  currency: '',
  etc: '',
}
export const ITEM_KEYS = Object.keys(ITEM_TEMPLATE)
